/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/*
// Author: Grin Zhou
*/

import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar, Button } from 'react-bootstrap';
import './BottomButtonsGroup.css';

const BottomButtonsGroup = (props) => {
  const completeFormAction = (event)=> {
    /*
    * 1. fix issue: when user click "Next" button, and validation checking is failed, "Next" button always on activity.
    * 2. callback the onClick action for the "Next" button.
    */
    event.target.blur();
    event.preventDefault();
    event.stopPropagation && event.stopPropagation();
    event.stopImmediatePropagation && event.stopImmediatePropagation();

    props.completeFormAction && props.completeFormAction();

    return false;
  };

  const backAction = (event)=> {
    /*
    * callback the onClick action for the "Back" button.
    */
    event.preventDefault();
    event.stopPropagation && event.stopPropagation();
    event.stopImmediatePropagation && event.stopImmediatePropagation();

    props.backAction && props.backAction();

    return false;
  };

  const saveAction = (event)=> {
    /*
    * callback the onClick action for the "Save" button.
    */
    event.preventDefault();
    event.stopPropagation && event.stopPropagation();
    event.stopImmediatePropagation && event.stopImmediatePropagation();

    props.saveAction && props.saveAction();

    return false;
  };

  return (
    <div className="form-bottom-buttons save-complete-btns clearfix">
      <div className="buttons-row">
        <ButtonToolbar>
          <Button
            bsStyle="primary"
            disabled={ props.disabled }
            onClick={ completeFormAction }
            data-key={ props.content.completeForm.dataKey }
          >
            { props.content.completeForm.text }
          </Button>
        </ButtonToolbar>
      </div>
      <div className="buttons-row">
        <ButtonToolbar>
          { props.backButtonShow &&
          <Button
            bsStyle="link"
            onClick={ backAction }
            data-key={ props.content.back.dataKey }
            className="btn-back"
            disabled={ props.backButtonDisabled }
          >
            <i aria-hidden={true} className="icon icon-chevron-left-small"></i>
            { props.content.back.text }
          </Button>
          }

          { props.saveButtonShow &&
          <Button
            bsStyle="link"
            onClick={ saveAction }
            data-key={ props.content.save.dataKey }
            className="btn-save"
            disabled={ props.saveButtonDisabled }
          >
            { props.content.save.text }
          </Button>
          }
        </ButtonToolbar>
      </div>
    </div>
  )
};

BottomButtonsGroup.propTypes = {
  content: PropTypes.object.isRequired,
  completeFormAction: PropTypes.func,
  backAction: PropTypes.func,
  disabled: PropTypes.bool,
  saveAction: PropTypes.func,
  saveButtonShow: PropTypes.bool,
  backButtonShow: PropTypes.bool,
  saveButtonDisabled: PropTypes.bool,
  backButtonDisabled: PropTypes.bool
};

BottomButtonsGroup.defaultProps = {
  content: {},
  saveButtonShow: true,
  backButtonShow: true,
  disabled: false,
  saveButtonDisabled: false,
  backButtonDisabled: false
};

export default BottomButtonsGroup;


// WEBPACK FOOTER //
// ./src/shared/AOForm/components/BottomButtonsGroup/index.js